var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ShowIf from "../../App/ShowIf";
import { Icon } from "../../UI";

import { openPanel } from "../actions/uiActions";

export class ViewerDefaultMenu extends Component {
  render() {
    return /*#__PURE__*/(
      _jsx("div", { className: this.props.active ? 'active' : '' }, void 0, /*#__PURE__*/
      _jsx(ShowIf, { if: !this.props.panelIsOpen }, void 0, /*#__PURE__*/
      _jsx("div", {
        className: "btn btn-primary",
        onClick: this.props.openPanel.bind(null, 'viewMetadataPanel') }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "columns" })))));




  }
}

const mapStateToProps = ({ documentViewer }) => ({
  panelIsOpen: !!documentViewer.uiState.get('panel'),
  doc: documentViewer.doc,
  targetDoc: !!documentViewer.targetDoc.get('_id')
});









ViewerDefaultMenu.contextTypes = {
  confirm: PropTypes.func
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ openPanel }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewerDefaultMenu);